<script lang="ts">
	import { getTokenStorage } from '../utils/localStorage';
	import QuickActions from '../components/QuickActions.svelte';
	import RecentRepositories from '../components/RecentRepositories.svelte';
	import ActivityFeed from '../components/ActivityFeed.svelte';
	import DeploymentStatus from '../components/DeploymentStatus.svelte';
	import Navbar from '../components/Navbar.svelte';
import { AppApiClient } from "../api_contracts/app.client";
  import { UserProfile } from "../api_contracts/app";
    import { appStore } from "../stores/appStore"; 
  import Index from './Index.svelte';
	let isAuthenticated = $state(false); 
  let client: AppApiClient | null = $state(null);
  let profile: UserProfile | null = $state(null);
  let token: string | null = $state(null);

	 // Subscribe to store
  appStore.subscribe((state) => {
    profile = state.profile;
    client = state.client;
    token = state.token;
  });


	// Check authentication status
	$effect(() => {
		// const token = getTokenStorage();
		// isAuthenticated = !!token;

		console.log("Home.svelte - Checking authentication status:");
		console.log("Token:", token);
		console.log("Client:", client);
		console.log("Profile:", profile);
		
		if (token !== null && token.length > 0 && client !== null && profile !== null) {

	  isAuthenticated = true;
	} else {
	  isAuthenticated = false;
	}
		
	});
</script>



{#if isAuthenticated}

<Navbar />

	<!-- Dashboard for authenticated users -->
	<div class="min-h-screen bg-gray-50 dark:bg-gray-950 ">
		<!-- Header Section -->
		<!-- <div class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
				<div class="flex items-center justify-between">
					<div>
						<h4 class="text-2xl font-bold text-gray-900 dark:text-gray-100">Dashboard</h4>
						<p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
							Welcome back! Here's what's happening with your projects.
						</p>
					</div>
					<div class="flex space-x-3">
						<a
							href="#/repositories/new"
							class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-500 dark:bg-indigo-700 dark:hover:bg-indigo-600 focus:outline-none focus:ring-1 focus:ring-indigo-600"
						>
							<svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M12 4v16m8-8H4"
								/>
							</svg>
							New Repository
						</a>
					</div>
				</div>
			</div>
		</div> -->

		<!-- Main Content -->
		<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
			<!-- Quick Actions -->
			<div class="mb-8">
				<QuickActions />
			</div>

			<!-- Two Column Layout -->
			<div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
				<!-- Left Column - Takes 2/3 on large screens -->
				<div class="lg:col-span-2 space-y-8">
					<!-- Recent Repositories -->
					<RecentRepositories />

					<!-- Activity Feed -->
					<ActivityFeed />
				</div>

				<!-- Right Column - Takes 1/3 on large screens -->
				<div class="lg:col-span-1">
					<!-- Deployment Status -->
					<DeploymentStatus />
				</div>
			</div>
		</div>
	</div>
{:else}
	<!-- Landing page for non-authenticated users -->
<Index></Index>
{/if}
